import { type ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { formatInrMinor } from '../../lib/constants';
import type { ParentPayment } from '../lib/parent-portal-api';

function formatPaidDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

function purposeClass(purpose: string): string {
  return purpose === 'REGISTRATION' ? 'purpose purpose-registration' : 'purpose purpose-subject';
}

export function PaymentRow({ payment }: { payment: ParentPayment }): ReactElement {
  return (
    <tr>
      <td>{formatPaidDate(payment.paidAt)}</td>
      <td>{payment.learnerName}</td>
      <td>
        <span className={purposeClass(payment.purpose)}>{payment.purposeLabel}</span>
      </td>
      <td className="money">{formatInrMinor(payment.amountMinor)}</td>
      <td>
        {payment.receiptId ? (
          <Link className="receipt-link" to={`/receipts/${payment.transactionId}`}>
            {payment.receiptNumber ?? 'View receipt'}
          </Link>
        ) : (
          '—'
        )}
      </td>
    </tr>
  );
}

export function PaymentTable({ items }: { items: ParentPayment[] }): ReactElement {
  if (items.length === 0) {
    return <p className="text-muted">No payments recorded yet.</p>;
  }

  return (
    <div className="table-wrap">
      <table className="data-table">
        <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Child</th>
            <th scope="col">Purpose</th>
            <th scope="col">Amount</th>
            <th scope="col">Receipt</th>
          </tr>
        </thead>
        <tbody>
          {items.map((payment) => (
            <PaymentRow key={payment.transactionId} payment={payment} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
